{
  "name": "@ns/add-subscription-card",
  "version": "1.1.0",
  "requiredPermission": "BILLING_MANAGE",
  "description": "Add new card to your nodeStream subscription",
  "inputs": {
    "subscriptionId": {
      "type": "string"
    }
  },
  "outcomes": {
    "complete": {}
  }
}
